import React, { useRef, useEffect, useCallback, useState} from 'react';
import {getBlockDate} from 'utils/getBlockDate.js';
import SourceResults from './SourceResults.js';
import {formatDate} from '../formatDate.js';
import {connect} from 'react-redux';
import {useScroll} from '../useScroll.js';

const DayResults = ({day, sequencerEngine, showPianoRoll, bottomHeight}) => { 
    let ref = useRef(undefined);

    let {unsourced, blockNumber} = day;
    let {size} = useScroll(ref, 24, true);
    let [date, setDate] = useState(undefined);

    useEffect(() => {
        getBlockDate(blockNumber).then(
            setDate);
    }, [blockNumber]);
 
    let unsourcedResults = [];
    for (let tag in unsourced) {
        unsourcedResults = [... unsourcedResults, ... unsourced[tag]];
    }
    let style = {
        height: window.innerHeight - 212
    };

    let i=0;
    let resultsCount = 0;
    let list = [];
    let resultsSize = size - resultsCount;

    if (resultsSize > 0 && unsourcedResults.length > 0) {
        list.push(
            <SourceResults
              odd={++i % 2 === 0}
              key={i}
              resultsSize={resultsSize}
              sequencerEngine={sequencerEngine}
              source={{results: unsourcedResults, tag: "Unsourced"}}/>
        );
    }

    return (
        <div style={style} ref={ref} className="day-results">
          <div className="date">
            <div className="day-date">{date ? formatDate(date) : ''}</div>
            {list}
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      showPianoRoll: state.sequencer.showPianoRoll,
      bottomHeight: state.arrangement.bottomHeight
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DayResults);
